<template>
  <div
    class="page--costcenter"
    :style="`min-height: ${height}px`"
  >
    <Header
      :kind="routeParams.type"
      :status="currentStatus"
      @bulkImport="$router.push({ name: 'CostCenterBulkOperation' })"
    />

    <Form
      :kind="routeParams.type"
      :submit="submitForm"
      :data="costCenterData"
      :status="currentStatus"
      @tryAgain="getCostCenterById"
      @setCurrentStatus="setCurrentStatus"
    />

    <Footer
      v-if="hasRole('costCenter', 'ROLE_POST_COSTCENTER') || hasRole('costCenter', 'ROLE_PUT_COSTCENTER_ID')"
      :kind="routeParams.type"
      :status="currentStatus"
      @submit="handleSubmit"
    />
  </div>
</template>

<script>
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'
import { mapActions } from 'vuex'
import { isArray, hasRole } from 'utils/functions'
// import moment from 'moment'
import Header from 'components/costCenter/Header'
import Form from 'components/costCenter/Form'
import Footer from 'components/costCenter/Footer'

export default {
  name: 'CostCenterPage',
  components: {
    Header,
    Form,
    Footer
  },
  computed: {
    routeParams () {
      return this.$route.params
    },

    height () {
      return document.body.offsetHeight
    }
  },
  data () {
    return {
      namespace: 'Views.CostCenterPage',
      submitForm: false,
      costCenterData: null,
      currentStatus: null
    }
  },
  methods: {
    ...mapActions({
      errorAlert: 'snackbarAlert/error'
    }),

    hasRole (group, role) {
      return hasRole(group, role)
    },

    isvalidArray: (val) => isArray(val),

    handleSubmit () {
      this.submitForm = !this.submitForm
    },

    renderPayload (val) {
      return {
        enabled: val.enabled,
        company: val.company,
        ownersList: val.owners,
        form: {
          id: val.id,
          name: val.name,
          companyId: val.companyId,
          temporaryDisabled: val.temporaryDisabled,
          automaticBlock: val.automaticBlock,
          ownerEmailOptIn: val.ownerEmailOptIn,
          owners: this.isvalidArray(val.owners) ? val.owners : [],
          budgetMonthlyLimit: val.budgetMonthlyLimit,
          extraMonthlyBudget: val.extraMonthlyBudget
        }
      }
    },

    setCurrentStatus (val) {
      if (val) this.currentStatus = val
    },

    setChatPosition (bottom = null, right = null) {
      const chat = document.querySelector('#oloswcdl-root .oloswebchat-main .cta-button')
      if (chat) {
        chat.style.bottom = bottom
        chat.style.right = right
      }
    },

    async getCompanyById (id) {
      try {
        const { data: res } = await this.$apiService.getCompanyById(id)
        return {
          id: res.data.id,
          name: res.data.name
        }
      } catch (err) {
        console.log('ERROR', err)
      }
    },

    async getCostCenterById () {
      if (this.routeParams.type === 'editar') {
        this.currentStatus = STATUS_IS_LOADING

        try {
          const costCenterId = Number(this.routeParams.id)
          const { data: res } = await this.$apiService.getCostCenterById(costCenterId)
          const company = await this.getCompanyById(res.data.companyId)
          this.costCenterData = this.renderPayload({
            ...res.data,
            company: {
              id: company.id,
              name: company.name
            }
          })

          this.currentStatus = STATUS_SUCCESS
        } catch (err) {
          let message = null
          console.log('ERROR', err)
          this.currentStatus = STATUS_FAILED

          if (err && err.response && err.response.status !== 404) {
            message = this.$t(`${this.namespace}.costCenterNotFoundMessage`)
            this.$router.push({ name: 'CostCenters' })
          } else {
            message = this.$t('Messages.genericError')
          }

          this.errorAlert(message)
        }
      }
    }
  },
  watch: {
    'routeParams.id' () {
      location.reload()
    }
  },
  beforeMount () {
    if (this.routeParams.type !== 'cadastrar' && this.routeParams.type !== 'editar') {
      this.$router.push({ name: 'CostCenters' })
    }
  },
  mounted () {
    this.getCostCenterById()

    if (this.routeParams.type !== 'editar') {
      this.currentStatus = STATUS_SUCCESS
    }

    this.setChatPosition('75px', '10px')
  },
  beforeDestroy () {
    this.setChatPosition()
  }
}
</script>
